import Numeral from "numeral";
import {isWhiteSpace} from "./utils";

export class MoneyHelper {
    static formatNumber(value: any, currencyDecimalDigits: number) {
        if (value == null || value === '' || isWhiteSpace(value) || isNaN(value))
            return value;

        const number = Number(value);
        const digits = Array.from({length: currencyDecimalDigits}, _ => '0').join('');

        const formatted = Numeral(number).format(`0[.]${digits}`);
        return formatted;
    }

    static parseCurrency(value: number | string, currencyGroupSeparator: string, currencyDecimalSeparator: string) {
        if (typeof value === "number")
            return value;

        const number = value
            .replace(new RegExp('\\' + currencyGroupSeparator, 'g'), '')
            .replace(new RegExp('\\' + currencyDecimalSeparator, 'g'), '.');
        return number;
    }
}

export default MoneyHelper;